import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import Reveal from "@/components/Reveal";

export default function Faq({ items, eyebrow = "Dúvidas Frequentes", title = "Antes de solicitar sua cotação", sectionId = "faq" }) {
    return (
        <section id={sectionId} className="bg-sand py-24 sm:py-32" data-testid="faq-section">
            <div className="mx-auto max-w-3xl px-4 sm:px-6">
                <Reveal className="text-center">
                    <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold-hover">{eyebrow}</p>
                    <h2 className="mt-3 font-serif text-3xl font-semibold tracking-tight text-forest-deep sm:text-4xl">
                        {title}
                    </h2>
                </Reveal>

                <Reveal delay={0.12} className="mt-12">
                    <Accordion type="single" collapsible className="space-y-3">
                        {items.map((f) => (
                            <AccordionItem
                                key={f.id}
                                value={f.id}
                                data-testid={`faq-item-${f.id}`}
                                className="rounded-2xl border border-[#E5DEC9] bg-white px-6 shadow-sm"
                            >
                                <AccordionTrigger
                                    data-testid={`faq-trigger-${f.id}`}
                                    className="py-5 text-left font-serif text-lg font-medium text-forest-deep hover:no-underline"
                                >
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-5 text-sm leading-relaxed text-stone-600">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
}
